const storeReducerDefaultState = {
    categories: {},
    loadingCategories: true,
    platform: null,
    categoryOrder: 'default'
};

export default (state = storeReducerDefaultState, action) => {
    switch (action.type) {
        case "SET_CATEGORIES":
            return {
                ...state,
                categories: action.payload,
                loadingCategories: false
            };
        case "CLEAR_CATEGORIES":
            return {
                ...state,
                categories: {}
            };       
        case "SET_PLATFORM":
            return {
                ...state,
                platform: action.payload
            };
        case "SET_CATEGORY_ORDER":            
            return {
                ...state,
                categoryOrder: action.payload
            };
        default:
            return state;
    }
};
  